"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.underlineExtension = exports.serializeToMarkdown = exports.imageExtension = exports.deserializeFromMarkdown = exports.cleanupEditorNodesForMarkdown = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _marked = require("marked");

var _prosemirrorMarkdown = require("prosemirror-markdown");

var _utils = require("../../utils");

var _image = require("../custom-extensions/image");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var serializerMarks = _objectSpread(_objectSpread({}, _prosemirrorMarkdown.defaultMarkdownSerializer.marks), {}, {
  bold: _objectSpread(_objectSpread({}, _prosemirrorMarkdown.defaultMarkdownSerializer.marks.strong), {}, {
    escape: false
  }),
  strike: {
    open: '~~',
    close: '~~',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  underline: {
    escape: false,
    open: '++',
    close: '++',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  italic: {
    open: '_',
    close: '_',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  link: _objectSpread(_objectSpread({}, _prosemirrorMarkdown.defaultMarkdownSerializer.marks.link), {}, {
    escape: false
  }),
  image: {
    open: '![',
    close: ')',
    mixable: false
  },
  // to ignore "highlight" (mark tag) from serializing
  highlight: {
    open: '',
    close: '',
    mixable: true,
    escape: true
  }
}); // Node type naming to serialize nodes provided by tiptap and prosemirror


var serializerNodes = _objectSpread(_objectSpread({}, _prosemirrorMarkdown.defaultMarkdownSerializer.nodes), {}, {
  paragraph: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.paragraph,
  bulletList: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.bullet_list,
  listItem: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.list_item,
  hr: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.horizontal_rule,
  horizontalRule: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.horizontal_rule,
  hardBreak: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.hard_break,
  orderedList: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.ordered_list,
  codeBlock: _prosemirrorMarkdown.defaultMarkdownSerializer.nodes.code_block
});

var markdownSerializer = new _prosemirrorMarkdown.MarkdownSerializer(serializerNodes, serializerMarks);

function escapeHTML(str) {
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;') // escaping only if > has anything before it, otherwise it is blockquote for markdown
  .replace(/^&gt; /gm, '> ');
}

var cleanupEditorNodesForMarkdown = function cleanupEditorNodesForMarkdown(editorJSON) {
  var _editorJSON$content;

  var filterNodes = function filterNodes(node) {
    if (node.marks) {
      // Remove TextStyle node which is added by TextStyle extension for coloring
      node.marks = node.marks.filter(function (mark) {
        return mark.type !== 'textStyle';
      });
    }

    if (node.content) {
      node.content = node.content.filter(filterNodes);
    } // TODO: implement markdown serialization for tables


    if (node.type) {
      return node.type !== 'table';
    }

    return true;
  };

  editorJSON.content = (_editorJSON$content = editorJSON.content) === null || _editorJSON$content === void 0 ? void 0 : _editorJSON$content.filter(filterNodes);
  return editorJSON;
};

exports.cleanupEditorNodesForMarkdown = cleanupEditorNodesForMarkdown;

var serializeToMarkdown = function serializeToMarkdown(editor) {
  var escape = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var editorJSON = cleanupEditorNodesForMarkdown(editor.getJSON());
  var proseMirrorDocument = editor.schema.nodeFromJSON(editorJSON);
  var md = markdownSerializer.serialize(proseMirrorDocument, {
    tightLists: true
  });
  return escape ? escapeHTML(md) : md;
};

exports.serializeToMarkdown = serializeToMarkdown;
var underlineExtension = {
  name: 'underline',
  level: 'inline',
  start: function start(src) {
    return src.indexOf(serializerMarks.underline.open);
  },
  tokenizer: function tokenizer(src) {
    var match = /^\+\++([^\n]+?)\+\++/.exec(src);

    if (match) {
      var _this$lexer;

      var token = {
        type: 'underline',
        raw: match[0],
        text: match[1],
        tokens: (_this$lexer = this.lexer) === null || _this$lexer === void 0 ? void 0 : _this$lexer.inlineTokens(match[1])
      };
      return token;
    }

    return undefined;
  },
  renderer: function renderer(token) {
    if (!token) return '';
    var html = token.text;

    if (token.tokens) {
      html = this.parser.parseInline(token.tokens);
    }

    return "<u>".concat(html, "</u>");
  }
};
exports.underlineExtension = underlineExtension;
var imageExtension = {
  name: 'image',
  level: 'inline',
  start: function start(src) {
    return src.indexOf(serializerMarks.image.open);
  },
  tokenizer: function tokenizer(src) {
    var newMatch = _image.imageMarkdownRegex.exec(src);

    if (newMatch) {
      var _newMatch = (0, _slicedToArray2.default)(newMatch, 6),
          raw = _newMatch[0],
          alt = _newMatch[2],
          _src = _newMatch[3],
          title = _newMatch[5];

      return {
        type: 'image',
        raw: raw,
        alt: alt,
        src: _src,
        title: title,
        id: (0, _utils.getUniqueId)('rte-image-')
      };
    }

    return undefined;
  },
  renderer: function renderer(token) {
    if (!token) return '';
    var titleString = token !== null && token !== void 0 && token.title ? "title=\"".concat(token.title, "\"") : '';
    var altString = token !== null && token !== void 0 && token.alt ? "alt=\"".concat(token.alt, "\"") : '';
    return "<img src=\"".concat(token.src, "\" ").concat(altString, " ").concat(titleString, " id=\"").concat(token.id, "\"/>");
  }
};
exports.imageExtension = imageExtension;

_marked.marked.use({
  extensions: [underlineExtension, imageExtension]
});

var renderer = new _marked.marked.Renderer();
var linkRenderer = renderer.link;

renderer.link = function (href, title, text) {
  var html = linkRenderer.call(renderer, href, title, text);
  return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer nofollow" ');
};

renderer.listitem = function (text) {
  return "<li><p>".concat(text, "</p></li>");
};

var deserializeFromMarkdown = function deserializeFromMarkdown(content) {
  var html = _marked.marked.parse(content, {
    headerIds: false,
    renderer: renderer
  });

  if (!html) return null; // Sanitizing markdown

  var parser = new DOMParser();

  var _parser$parseFromStri = parser.parseFromString(html, 'text/html'),
      body = _parser$parseFromStri.body;

  return body.innerHTML;
};

exports.deserializeFromMarkdown = deserializeFromMarkdown;